module.exports = __webpack_public_path__ + "static/media/about-us-2.68e48e99.jpg";